import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { Container, Content } from "./styles";
import { Link } from "react-router-dom";

export default function PrivacyPolitics() {
  return (
    <Container>
      <Header />
      <Content>
        <h2>Política de Privacidade da 7Cantos</h2>
        <p className="last-update">Última atualização: 06 de junho de 2025</p>
        <p>
          A 7Cantos respeita a sua privacidade e está comprometida em proteger os
          dados pessoais que você compartilha conosco. Esta Política de
          Privacidade descreve como realizamos o tratamento de dados pessoais,
          conforme as exigências da Lei Geral de Proteção de Dados Pessoais
          (LGPD - Lei nº 13.709/2018). Ao acessar ou utilizar os serviços
          digitais da 7Cantos, incluindo o nosso Marketplace, você declara estar
          ciente e de acordo com os termos aqui estabelecidos.
        </p>
        <h3>1. Quem Somos</h3>
        <p>
          A 7Cantos é uma empresa de aluguel de imóveis que tem como objetivo
          revolucionar o mercado de imóveis residenciais, conectando
          proprietários e inquilinos de forma desburocratizada, ágil e digital.
          Nosso serviço permite que usuários encontrem imóveis disponíveis ou
          anunciem seus próprios imóveis de maneira prática e eficiente.
        </p>
        <h3>2. Quais Dados Pessoais Coletamos</h3>
        <p>
          Coletamos e tratamos dados pessoais com a finalidade de melhorar a
          navegação em nosso site, prestar atendimento, processar transações,
          enviar comunicações relevantes e cumprir obrigações legais. As
          informações podem incluir dados cadastrais, de navegação, de pagamento
          e outros fornecidos por você ou por terceiros relacionados, conforme
          necessário para a prestação de nossos serviços. O tratamento desses
          dados é realizado de acordo com a legislação aplicável,
          especialmente a Lei Geral de Proteção de Dados (LGPD), garantindo
          segurança, confidencialidade e respeito aos seus direitos.
        </p>
        <h3>3. Compartilhamento de Informações</h3>
        <p>
          Não compartilhamos suas informações pessoais com terceiros, exceto
          quando necessário para fornecer os serviços solicitados por você ou
          quando exigido por lei.
        </p>
        <h3>4. Armazenamento e Segurança dos Dados</h3>
        <p>
          Adotamos medidas técnicas e administrativas de segurança da informação
          adequadas para proteger os dados pessoais contra acesso não
          autorizado, destruição, perda, alteração ou qualquer forma de
          tratamento inadequado ou ilícito. Os dados são armazenados em
          servidores seguros e controlados, podendo estar localizados no Brasil
          ou em países que garantam o mesmo nível de proteção previsto na LGPD.
        </p>
        <h3>5. Cookies e Tecnologias de Rastreamento</h3>
        <p>
          Utilizamos cookies e tecnologias similares para melhorar sua
          experiência em nossa plataforma. Você pode gerenciar suas preferências
          de cookies por meio das configurações do seu navegador.
        </p>
        <h3>6. Alterações a esta Política</h3>
        <p>
          Podemos atualizar esta Política de Privacidade periodicamente. A
          versão mais atual estará sempre disponível em nosso site, com a data
          de última atualização indicada no início do documento.
        </p>
        <h3>7. Fale Conosco</h3>
        <p>
          Se você tiver dúvidas sobre esta Política de Privacidade ou desejar
          exercer seus direitos como titular de dados, entre em contato com
          nosso Encarregado de Proteção de Dados (DPO) pelo e-mail:
          <br />
          📧 contato@7cantos.com
        </p>
        <p className="agreement">
          Ao acessar nosso site, você concorda com esta Política de Privacidade e
          com os <Link to="/use-terms">Termos de Uso</Link>. Se você tiver alguma
          dúvida ou preocupação sobre nossas práticas de privacidade ou termos
          de uso, entre em contato conosco através das informações fornecidas em
          nosso site.
        </p>
      </Content>
      <Footer />
    </Container>
  );
}